import { useCallback, useEffect, useRef, useState } from 'react';

export const useLoadingFunction = (func: any, throwOnError = true): [any, boolean, Error | null] => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isMountedRef = useRef(true);

  useEffect(
    () => () => {
      isMountedRef.current = false;
    },
    []
  );

  const wrappedClick = useCallback(
    async (...args: any[]) => {
      setLoading(true);
      let ret;
      try {
        ret = await func(...args);
      } catch (e) {
        setError(e);
        if (throwOnError) throw e;
      }

      if (isMountedRef.current) setLoading(false);

      return ret;
    },
    [func, throwOnError]
  );

  return [wrappedClick, loading, error];
};
